import React from 'react';
import { TurnAnalysisTurn } from '../types/api';
import AgentAssistCard from './AgentAssistCard';
import '../styles/components/LiveAnalysisTab.css';

interface LiveAnalysisTabProps {
  turns: TurnAnalysisTurn[];
  loading: boolean;
  error?: string | null;
  onJumpToTime?: (timestamp: string) => void;
}

const LiveAnalysisTab: React.FC<LiveAnalysisTabProps> = ({
  turns,
  loading,
  error,
  onJumpToTime,
}) => {
  if (loading) {
    return <div className="live-analysis-state">Loading live analysis…</div>;
  }

  if (error) {
    return <div className="live-analysis-state live-analysis-error">{error}</div>;
  }

  if (!turns.length) {
    return <div className="live-analysis-state">No turn analysis available.</div>;
  }

  return (
    <div className="live-analysis-tab">
      {turns.map((turn) => (
        <div key={turn.speech_text_id} className="live-analysis-turn">
          <div className="live-analysis-turn-header">
            <button
              type="button"
              className="live-analysis-timestamp"
              onClick={() => onJumpToTime?.(turn.timestamp || '')}
            >
              {turn.timestamp || '--:--'}
            </button>
            <span className="live-analysis-speaker">{turn.speaker}</span>
            <span className="live-analysis-turn-number">Turn {turn.turn_number}</span>
          </div>
          <div className="live-analysis-text">{turn.text}</div>

          <AgentAssistCard card={turn.agent_card} />
        </div>
      ))}
    </div>
  );
};

export default LiveAnalysisTab;

